// extracted by mini-css-extract-plugin
module.exports = {"stepperPrecise":"style_stepperPrecise__2Vr1q","stepperPrecise_currentValue":"style_stepperPrecise_currentValue__LAt_G"};